<template>
    <div class="card bd-0">
        <div class="card-body p-0">
            <div v-if="loading" class="align-content-center my-5"><spinner-component :loading="loading" /></div>
            <div v-if="error" class="tx-center tx-danger">{{ error }}</div>
            <div v-else>
                <canvas v-show="!loading && chart" id="chart" width="400" height="400"></canvas>
                <p v-show="!loading && !chart" class="text-center my-5">No Data Available</p>
            </div>
            
        </div>
    </div>
</template>

<script>
	import Chart from "chart.js";

	export default {
		data() {
			return {
				loading: false,
				chart: null,
				error: null
			};
		},
		created() {
			this.fetchChart();
		},
		computed: {
			isGhsLiquidity() {
				return (
					["ghs-liquidity-portfolio", "ic-liquidity-fund"]
					.includes(slugify(this.portfolioType, { lower: true }))
				);
			}
		},
		methods: {
			fetchChart() {
				this.error = this.chart = null;
				this.loading = true;

				axios
					.get(`/api/portfolio/${this.$route.params.portfolio}/chart`, {
						params: {
							type: "chart"
						}
					})
					.then(response => {
						const chart = response.data.data.chart;

						if (!_.isEmpty(chart)) {
							this.chart = chart;
						}
					})
					.catch(error => {
						this.error = error.toString();
					})
					.finally(() => {
						this.loading = false;

						if (!_.isEmpty(this.chart.datasets[0].values[0])) {
							this.createChart();
						} else {
							this.chart = null;
						}
					});
			},
			createChart() {
				const ctx = document.getElementById("chart").getContext("2d");
				new Chart(ctx, {
					type: this.chart.datasets[0].type,
					data: {
						datasets: [
							{
								data: this.chart.datasets[0].values[0],
								backgroundColor: this.chart.datasets[0].options
									.backgroundColor,
								borderColor: this.chart.datasets[0].options
									.borderColor,
								label: this.chart.datasets[0].name
							}
						],
						labels: this.chart.labels
					},
					options: {
						legend: this.chart.options.legend,
						responsive: this.chart.options.responsive,
						tooltips: {
							callbacks: {
								label: (tooltipItem, data) => {
									var dataLabel = data.labels[tooltipItem.index];
									var value =
										": " +
										this.$options.filters.toNumber(
											data.datasets[tooltipItem.datasetIndex]
												.data[tooltipItem.index],
											"0,0.00"
										);

									if (Chart.helpers.isArray(dataLabel)) {
										dataLabel = dataLabel.slice();
										dataLabel[0] += value;
									} else {
										dataLabel += value;
									}

									return this.isGhsLiquidity
										? `${dataLabel}%`
										: dataLabel;
								}
							}
						}
					}
				});
			}
		},
		props: ["portfolioId", "portfolioType"]
	};
</script>
